/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const Page = {
  path: '/page',
  name: 'page',
  redirect: { name: 'page-redirect' },
  component: () => import('@/views/page/index.vue'),
  children: [
    {
      path: 'redirect',
      name: 'page-redirect',
      component: () => import(/* webpackChunkName: "page" */ '@/views/page/redirect.vue'),
    },
  ],
}
export default Page
